import React, { useEffect, useState } from 'react'
import { Button, Row, Spinner } from 'react-bootstrap';
import Pagination from '../Layout/Pagination';
import CardProductContainer from '../Products/CardProductContainer';
import UseGetAllFavorite from '../../CustomHooks/Favorite/UseGetAllFavorite';
import { Link } from 'react-router-dom';

const UserFavoriteProductComp = () => {
  const [favList, allFavorites, loading] = UseGetAllFavorite()
  return (
    <>
      {
        loading === false ?
          (allFavorites && allFavorites.length >= 1 ? (
            <div className='mh-100-exact'>
              <Row className='justify-content-start'>
                <CardProductContainer products={allFavorites} title="Wishlist"/>
              </Row>
            </div>
          ) : (
            <div className='d-flex align-items-center flex-column justify-content-center mh-100-exact'>
              <h3 className='fs-60'>No Wishlist</h3>
              <Link to="/">
                <Button className='orange-bg border-0 px-4 py-3 fs-30'>Go Shopping</Button>
              </Link>
            </div>
          )) : (
            <div className='d-flex align-items-center flex-column justify-content-center mh-100-exact'>
              <Spinner animation="border" variant="danger" />
            </div>
          )
      }

    </>
  )
}

export default UserFavoriteProductComp
